import { FooterData, FooterRow } from './types';

export const footerRow: FooterRow = {
  format: null,
  variant: null,
  budget: null,
  weeks: null,
  grp: null,
  split: null,
};
export const defaultData: FooterData = {
  totalOffline: footerRow,
  // otherCosts: footerRow,
  techCosts: footerRow,
  totalBudget: footerRow,
};
